import { Alert, App, Button, Card, Form, Space } from 'antd'
import { useEffect, useState } from 'react'
import { DEFAULT_ERROR, DEFAULT_SUCCESS } from '../../App'
import { HomeSection } from '../../models/HomeSection'
import {
  fetchClosestClusterTitle,
  updateClosestClusterTitle,
} from '../../services/ClusterService'
import { requiredRule } from '../../utils/rules'
import { Localizable } from '../localizable/Localizable'

const ClosestClusterTitle = () => {
  const { message } = App.useApp()
  const [form] = Form.useForm()

  const [data, setData] = useState<HomeSection | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    setIsLoading(true)
    fetchClosestClusterTitle()
      .then((result) => {
        setData(result)
      })
      .finally(() => setIsLoading(false))
  }, [])

  const onFormFinish = (values: any) => {
    updateClosestClusterTitle(values)
      .then(() => {
        message.success(DEFAULT_SUCCESS)
      })
      .catch(() => {
        message.error(DEFAULT_ERROR)
      })
  }

  useEffect(() => {
    form.setFieldsValue(data)
  }, [data])

  return (
    <Card loading={isLoading}>
      <Space orientation="vertical">
        <Alert
          type="warning"
          showIcon
          title={`The closest cluster from the app user is shown as a vertical list.
            Others are displayed separately as horizontal lists. For the closest cluster you can customize the
            title below.`}
        />
        <Form form={form} layout="horizontal" onFinish={onFormFinish}>
          <Space.Compact className="w-full">
            <Localizable.Input
              name={'title'}
              max={20}
              noStyle
              rules={[requiredRule()]}
            />
            <Button
              loading={isLoading}
              disabled={isLoading}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
          </Space.Compact>
        </Form>
      </Space>
    </Card>
  )
}

type ClosestClusterTitleType = {
  ClosestClusterTitle: typeof ClosestClusterTitle
}

export { ClosestClusterTitle, type ClosestClusterTitleType }
